<template>
  <div class="wx-login">
    <div id="wx_login_container"></div>
  </div>
</template>

<script type="text/javascript" src="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>

<script>
import website from '@/config/website'
import { getWxLogin } from '@/api/system'

export default {
  name: 'wx-login',
  data() {
    return {
      dialogVisible: false,
    }
  },
  mounted() {
    this.getWxCode()
  },
  methods: {
    getRandomString(length = 32) {
      let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
        num = ''
      for (let i = 0; i < length; i++) {
        num += arr[parseInt(Math.random() * 36)]
      }
      return num
    },
    getWxCode() {
      var obj = new WxLogin({
        self_redirect: false,
        id: 'wx_login_container',
        appid: website.wxAppid,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(`${website.redirect_url}/bindphone`),
        state: encodeURIComponent(this.getRandomString(32)),
        style: 'black',
        href: '',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wx-login {

  #wx_login_container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    color: #000000;
  }
}
</style>